import { MutableRefObject, ReactNode, useRef } from "react";

type SnapSectionProps = {
  id: string;
  children?: ReactNode;
  sectionRef?: MutableRefObject<HTMLElement | null>;
  autoHeight?: boolean;
};

/**
 * Full-height snap-aligned section wrapper.
 */
export function SnapSection({ id, children, sectionRef, autoHeight = false }: SnapSectionProps) {
  const fallbackRef = useRef<HTMLElement | null>(null);
  const ref = sectionRef ?? fallbackRef;

  return (
    <section
      id={id}
      data-snap-section
      className="relative snap-start snap-always grid place-items-center"
      style={
        { minHeight: "calc(var(--vh, 1vh) * 100)" }
      }
      ref={ref as any}
    >
      {children}
    </section>
  );
}
